import React from "react";

// COMPONENTS
import BackPageBtn from "../../components/Buttons/PrevPage";

function SectionTitle({ id, isBackButton, title, description }) {
  return (
    <section
      {...(id ? (id = { id }) : null)}
      className="section__header--description"
    >
      <div className="container">
        {isBackButton ? (
          <div className="content-bar">
            <BackPageBtn />
          </div>
        ) : null}
        <div className="description__header">
          <h2>{title}</h2>
          {description ? <p>{description}</p> : null}
        </div>
      </div>
    </section>
  );
}

export default SectionTitle;
